


























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { StoreModel, StoreConfig } from '@/models/admin/store';
import { Base } from '@/components/common/base';
import {storeService} from '@/shared';
import { ValidationRules } from '@/helper/enum';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class StoreConfigPage extends Base {
  public storeViewModel: StoreModel = {};
  public storeModel: StoreModel = {};
  public storeConfigModel: StoreConfig = {};
  public form: any = {};
  public formFields: Array<VFields<any>> = [];
  public storeId: number = 0;
  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public requestProgress: boolean = false;

  public callMethod(methodName): void {
    if (methodName === 'backToStoreEdit') {
      this.$router
        .push({
          name: 'admin.stores.edit',
          params: { id: this.storeId.toString(), tab: 'StoreConfig' },
        })
        .catch((ex) => {console.log(ex);});
    }
    if (methodName === 'submit') {
      if (!this.form.$valid) {
        this.showAlert(false, this.$t('stores.storeConfig.alertInvalidForm'));
        this.resetMethodName(methodName);
        return;
      }
      this.savestoreconfig();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    if (this.storeId) {
      buttons.push({
        id: '0',
        type: 'button',
        title: this.$parent.$t('stores.btnBackToStoreTitle'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t('stores.btnBack'),
        click: 'backToStoreEdit',
        icon: 'fas fa-arrow-left',
      });
    }
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    this.setFields();
    if (this.$route.params.storeId) {
      this.storeId = Number(this.$route.params.storeId);
      this.getStoreConfigInfo();
    }

    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
  }
  public setFields(): void {
    this.formFields = [
      {
        key: 'expenseReminderTimeInterval',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: true,
          label: this.$t(
            'stores.storeConfig.ConfigFields.expenseReminderTimeInterval'
          ) as string,
          counter: 50,
          type: 'number',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Expense Reminder Time Interval', v)
          ]
        },
      },
      {
        key: 'poFailedSyncJobTime',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: true,
          label: this.$t(
            'stores.storeConfig.ConfigFields.poFailedSyncJobTime'
          ) as string,
          counter: 50,
          type: 'number',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('PO Failed Sync Job Time', v)
          ]
        },
      },
      {
        key: 'poFailedSyncMinTime',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: true,
          label: this.$t(
            'stores.storeConfig.ConfigFields.poFailedSyncMinTime'
          ) as string,
          counter: 50,
          type: 'number',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('PO Failed Sync Min Time', v)
          ]
        },
      },
      {
        key: 'vehicleDaysToSync',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: true,
          label: this.$t(
            'stores.storeConfig.ConfigFields.vehicleDaysToSync'
          ) as string,
          counter: 200,
          type: 'number',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Vehicle Days To Sync', v)
          ]
        },
      },
      {
        key: 'expenseVendorScheduleMailTime',
        required: true,
        type: 'v-alynk-timepicker',
        templateOptions: {
          disabled: false,
          required: true,
          label: this.$t(
            'stores.storeConfig.ConfigFields.expenseVendorScheduleMailTime'
          ) as string,
          counter: 50,
          time: true,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Expense Vendor Schedule Mail Time',v)
          ]
        },
      },
      {
        key: 'appoinmentMessageReminderSync',
        required: true,
        type: 'v-alynk-timepicker',
        templateOptions: {
          disabled: false,
          required: true,
          label: this.$t(
            'stores.storeConfig.ConfigFields.appoinmentMessageReminderSync'
          ) as string,
          counter: 50,
          time: true,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Appoinment Message Reminder Sync',v)
          ]
        },
      },
      {
        key: 'chargeCustomerSchedulerTime',
        required: true,
        type: 'v-alynk-timepicker',
        templateOptions: {
          disabled: false,
          required: true,
          label: this.$t(
            'stores.storeConfig.ConfigFields.chargeCustomerSchedulerTime'
          ) as string,
          counter: 50,
          time: true,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Charge Customer Scheduler Time', v)
          ]
        },
      },
      {
        key: 'appointmentResponseValidHours',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: true,
          label: this.$t(
            'stores.storeConfig.ConfigFields.appointmentResponseValidHours'
          ) as string,
          counter: 3,
          type: 'number',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Appointment Valid Retrieval', v)
          ]
        },
      },
      ,
      {
        key: 'partSalesDelayMinutes',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: true,
          label: this.$t(
            'stores.storeConfig.ConfigFields.partSalesDelayMinutes'
          ) as string,
          counter: 3,
          type: 'number',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',   
          rules:[
            v => this.required('Part Sales Delay Minutes', v)
          ]   
        },
      },
      {
        key: 'partSalesDaysToSync',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: true,
          label: this.$t(
            'stores.storeConfig.ConfigFields.partSalesDaysToSync'
          ) as string,
          counter: 200,
          type: 'number',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Part Sales Days To Sync', v)
          ] 
        },
      },
      {
        key: 'isPartSalesSyncEnabled',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          label: this.$t(
            'stores.storeConfig.ConfigFields.isPartSalesSyncEnabled'
          ) as string,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
        },
      },
    ];
  }
  public async getStoreConfigInfo(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.formFields);
      const response = await storeService.getStoreConfig(this.storeId);
      this.storeConfigModel = response;
    } finally {
      this.formlyHideSkeleton(this.formFields);
    }
  }

  public validateStoreConfig(): Vue & { validate: () => boolean } {
    return this.$refs.storeConfigForm as Vue & { validate: () => boolean };
  }

  public async savestoreconfig(): Promise<void> {
    if(this.validateStoreConfig().validate()){
      try {
        this.requestProgress = true;
        this.$emit('update:progress', this.requestProgress);
        await storeService.AddorUpdateStoreConfig(
          this.storeId,
          this.storeConfigModel
        );
        this.showAlert(true, this.$t('stores.storeConfig.alertConfigSaved'));
        this.$router.push({
          name: 'admin.stores.edit',
          params: {
            tenantId: this.tenantId.toString(),
            enterpriseId: this.enterpriseId.toString(),
            storeId: this.storeId.toString(),
            tab:'StoreConfig'
          },
        });
      } finally {
        this.requestProgress = false;
        this.$emit('update:progress', this.requestProgress);
      }
    }
  }
}
